import React, { useState, useRef, useEffect } from "react";
import useDarkMode from "../../hooks/useDarkMode";

export default function InfoPopover({ text }) {
  const [open, setOpen] = useState(false);
  const ref = useRef();
  const dark = useDarkMode();

  useEffect(() => {
    const handle = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("click", handle);
    return () => document.removeEventListener("click", handle);
  }, []);

  return (
    <span ref={ref} style={{ position: "relative", display: "inline-block" }}>
      <button
        type="button"
        onClick={(e) => {
          e.stopPropagation();
          setOpen((o) => !o);
        }}
        aria-label="More info"
        style={{
          border: `1px solid ${dark ? "#8d99ae" : "#7f8c8d"}`,
          background: dark ? "#444" : "#ecf0f1",
          cursor: "pointer",
          padding: 0,
          marginLeft: 8,
          color: dark ? "#f3f3f3" : "#2c3e50",
          fontSize: 11,
          width: 18,
          height: 18,
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        i
      </button>
      {open && (
        <div
          style={{
            position: "absolute",
            zIndex: 10,
            top: "100%",
            left: "50%",
            transform: "translateX(-50%)",
            background: dark ? "#2d2d2d" : "#fff",
            border: `1px solid ${dark ? "#555" : "#ccc"}`,
            borderRadius: 4,
            padding: 8,
            boxShadow: dark
              ? "0 12px 24px rgba(0,0,0,0.45)"
              : "0 2px 6px rgba(0,0,0,0.2)",
            width: 200,
            color: dark ? "#f3f3f3" : "#2c3e50",
          }}
        >
          {text}
        </div>
      )}
    </span>
  );
}
